import CreateUpdatePortfolioDialog, {
  type CreateUpdatePortfolioDialogDefProps,
} from './CreateUpdatePortfolioDialog.tsx';
import type { ReactElement, ReactNode } from 'react';
import type { AccountLabelInputAccount } from '../../../../portfolio/account/AccountLabel.tsx';
import type { SubfundAutocompleteOptionInput } from '../../../../portfolio/fund/SubFundService.tsx';
import { DialogMenuItem } from '../../../../technical/DialogDropdown/DialogMenuItem.tsx';

const CreateUpdatePortfolioDialogItem = ({
  def,
  availableAccounts,
  subFunds,
  children,
}: {
  def: CreateUpdatePortfolioDialogDefProps;
  availableAccounts?: AccountLabelInputAccount[];
  subFunds?: SubfundAutocompleteOptionInput[];
  children?: ReactNode;
}): ReactElement => (
  <DialogMenuItem
    renderDialog={({ onClose }): ReactElement => (
      <CreateUpdatePortfolioDialog
        onClose={onClose}
        onCompleted={onClose}
        def={def}
        multifactors={[]}
        accounts={availableAccounts}
        subFunds={subFunds}
      />
    )}
  >
    {children}
  </DialogMenuItem>
);

export default CreateUpdatePortfolioDialogItem;
